import { Endpoint } from "shared/utils/endpoints";
import { HTTP_CLIENT } from "shared/utils/interceptor";

const GetAllBrandsService = (page = 1, limit = 100) => {
  return HTTP_CLIENT.get(
    `${Endpoint.productBrands.getBrands}?&page=${page}&limit=${limit}`
  );
};

const GetBrandByCategoryService = (type = "ATV") => {
  return HTTP_CLIENT.get(
    `${Endpoint.productBrands.getBrandByCategory}?type=${type}`
  );
};

const GetProductCategoriesService = () => {
  return HTTP_CLIENT.get(Endpoint.productBrands.getCategories);
};

const CreateProductBrandService = (data: FormData) => {
  return HTTP_CLIENT.post(`${Endpoint.productBrands.createBrand}`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

const UpdateProductBrandService = (data: FormData, id: string) => {
  return HTTP_CLIENT.patch(
    `${Endpoint.productBrands.updateBrand.replace(":id", id)}`,
    data,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};

const DeleteProductMakeService = (id: string) => {
  return HTTP_CLIENT.delete(
    Endpoint.productBrands.deleteBrand.replace(":id", id)
  );
};

export {
  GetAllBrandsService,
  CreateProductBrandService,
  GetProductCategoriesService,
  UpdateProductBrandService,
  GetBrandByCategoryService,
  DeleteProductMakeService,
};
